import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { PlatbaTyp } from '@/modules/uctenky/fakturace/constants';

import { NAME as name, CRUMB_LABEL_KEY as crumbLabel } from '../constants';
import { apiProvider } from '../api';

const edit = {
	PcSDph: null as number | null,
	PrijemceTitulPred: null as string | null,
	PrijemcePrijmeniFirma: null as string | null,
	PrijemceJmeno: null as string | null,
	PrijemceUlice: null as string | null,
	PrijemceStat: null as string | null,
	PrijemcePscNr: null as string | null,
	PrijemceObec: null as string | null,
	DrzitelPrijmeniFirma: null as string | null,
	DuzpDat: null as Date | null,
	PrijemceIcoNr: null as string | null,
	KaroserieNr: null as string | null,
	KdokladPfx: null as string | null,
	KrukTitulPred: null as string | null,
	KrukamJmeno: null as string | null,
	KrukamPrijm: null as string | null,
	Osloveni: null as string | null,
	ProvozovnaId: null as number | null,
	SplatnostDat: null as Date | null,
	Spz: null as string | null,
	Terminal: null as string | null,
	Typkod: null as string | null,
	UzavreniDat: null as Date | null,
	VozidloId: null as number | null,
	VstupDat: null as Date | null,
	VstupPracId: null as number | null,
	VyrobekvozOzn: null as string | null,
	ZakaznikId: null as number | null,
	ZakaznikIdText: null as string | null,
	ZakaznikSk: null as number | null,
	ZalozeniDat: null as Date | null,
	PovId: null as number | null,
	DokladNr: null as number | null,
	KdokladNr: null as number | null,
	PrijemceKontoNr: null as number | null,
	PrijemceDicNr: null as string | null,
	DokladDruh: null as string | null,
	DokladovId: null as number | null,
	DokladPfx: null as string | null,
	KomiseovNr: null as string | null,
	TypkodText: null as string | null,
	PovNr: null as number | null,
	VyrobekvozText: null as string | null,
	BarvaKod: null as string | null,
	BarvaText: null as string | null,
	PovPzn: null as number | null,
	Pov2Pzn: null as number | null,
	LeassmlouNr: null as string | null,
	Leaspodminky: null as string | null,
	DrzitelUlice: null as string | null,
	DrzitelPscNr: null as string | null,
	DrzitelObec: null as string | null,
	DrzitelIcoNr: null as string | null,
	DrzitelDicNr: null as string | null,
	MotorNr: null as string | null,
	TpNr: null as string | null,
	KmStav: null as number | null,
	VyrizujePrijm: null as string | null,
	FakturantPrijm: null as string | null,
	VyrizujeOsobniCis: null as string | null,
	FakturantOsobniCis: null as string | null,
	VyrizujeId: null as number | null,
	PlatbaPzn: null as PlatbaTyp | null,
	PlatbaText: null as string | null,
	OvprijemkaPfx: null as string | null,
	OvprijemkaNr: null as number | null,
	PcSlevaPred: null as number | null,
	IntrDruhOzn: null as number | null,
	IntrDruh: null as string | null,
	IntrDruhDuvod: null as string | null,
	DoplnekMk: null as string | null,
	PovzalohaId: null as number | null,
	DrzitelKontoNr: null as number | null,
	DrzitelStat: null as string | null,
	SidloPrp: null as boolean | null,
	IbsKod: null as string | null,
	IbsText: null as string | null,
	IbsPrp: null as boolean | null,
	SkladovOzn: null as number | null,
	VyrobaRok: null as string | null,
	LeaszakaznikId: null as number | null,
	KdokladovId: null as number | null,
	OvkategPzn: null as number | null,
	DphrozpadPrp: null as boolean | null,
	SidlozakaznikId: null as number | null,
	Sidlo: null as string | null,
	SidloUlice: null as string | null,
	SidloPscNr: null as string | null,
	SidloObec: null as string | null,
	SidloIcoNr: null as string | null,
	SidloDicNr: null as string | null,
	SidloKontoNr: null as number | null,
	SidloStat: null as string | null,
	OcCelkSml: null as number | null,
	PovzalohaNr: null as number | null,
	PrijemceIdDoklNr: null as string | null,
	SidloIdDoklNr: null as string | null,
	PrijemceIcDphNr: null as string | null,
	SidloIcDphNr: null as string | null,
	DrzitelIcDphNr: null as string | null,
	Kupuj: null as string | null,
	KupujUlice: null as string | null,
	KupujPscNr: null as string | null,
	KupujObec: null as string | null,
	KupujIcoNr: null as string | null,
	KupujDicNr: null as string | null,
	KupujKontoNr: null as number | null,
	KupujStat: null as string | null,
	KupujIdDoklNr: null as string | null,
	KupujIcDphNr: null as string | null,
	KupujzakaznikId: null as number | null,
	BankaBic: null as string | null,
	BankaIban: null as string | null,
	BankaTxt: null as string | null,
	BankaUcet: null as string | null,
	HefPrp: null as boolean | null,
	PokladnaId: null as number | null,
	JinyprijemceId: null as number | null,
	PrijemceTitulZa: null as string | null,
	MenaId1: null as number | null,
	MenaId2: null as number | null,
	KurzM2: null as number | null,
	Kurzstr: null as string | null,
	PreshrprodPrp: null as boolean | null,
	DphPlatcePrp: null as boolean | null,
	DobropduvodRtf: null as string | null,
	PalivoPzn: null as number | null,
	Objem: null as number | null,
	NarozeniDat: null as Date | null,
	SmlouvaTyp: null as number | null,
	PrijemceKns: null as number | null,
	DrzitelKns: null as number | null,
	KupujKns: null as number | null,
	ArcProvozovnaId: null as number | null,
	ArcDokladdruhId: null as number | null,
	ArcDokladDruhText: null as string | null,
	DoklPdfFileName: null as string | null,
	ZakaznikOsobniCis: null as string | null,
	BankaTxt2: null as string | null,
	BankaUcet2: null as string | null,
	BankaIban2: null as string | null,
	BankaBic2: null as string | null,
	FakturantJmeno: null as string | null,
	DokladnrStylPzn: null as number | null,
	KdokladnrStylPzn: null as number | null,
	Doklad3Id: null as number | null,
	VyrizujeJmeno: null as string | null,
	DrzitelTitulPred: null as string | null,
	DrzitelTitulZa: null as string | null,
	DrzitelJmeno: null as string | null,
	ZvlrdphPouzitezbPrp: null as boolean | null,
	TextLongExkluzivni: null as string | null,
	TextPlain: null as string | null,
	CanDobropis: null as boolean | null,
	CanPolozkovyDobropis: null as boolean | null,
	CanStorno: null as boolean | null,
	CanVrubopisCastecnyDobropis: null as boolean | null,
};

export const store = editStoreBuilder({
	apiProvider,
	crumbLabel,
	depTableNames: [],
	depTableSettings: {},
	dropdownList: {
		ProvozovnaId: [],
		PlatbaPzn: [],
		PovPzn: [],
		Pov2Pzn: [],
		VyrobekvozOzn: [],
	},
	edit,
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	localState: {},
	name,
	props: {
		mode: null,
	},
});
